export function octiconLink() {
  return {
    type: 'element',
    tagName: 'span',
    properties: {
      class: 'octicon octicon-link'
    },
    children: []
  };
}